import PageTitle from 'components/ui/pageTitle/pageTitle'
import React from 'react'
import ContactForm from './components/contactForm/contactForm'

export default function Contact() {
  return (
    <>
      <PageTitle>Contact</PageTitle>
      <ContactForm />
    </>
  )
}
